import { TemplateTranslations } from "./types"

// update if needed
export const templateTranslations: TemplateTranslations = {
    hr: {
        areaLabel: 'Površina',
        bedroomsLabel: 'Spavaće sobe',
        propertyService: {
            1: 'Prodaja', 
            2: 'Najam/Zakup',
        },
        propertyType: {
            1: 'Kuća',
            2: 'Stan',
            3: 'Poslovni prostor',
            4: 'Zemljište',
            5: 'Garaža',
        },
    },
    en: {
        areaLabel: 'Area',
        bedroomsLabel: 'Bedrooms',
        propertyService: {
            1: 'Sale',
            2: 'Rent',
        },
        propertyType: {
            1: 'House',
            2: 'Apartment',
            3: 'Business premise',
            4: 'Land',
            5: 'Garage',
        },
    },
    sl: {
        areaLabel: 'Površina',
        bedroomsLabel: 'Spalnice',
        propertyService: {
            1: 'Prodaja',
            2: 'Najem',
        },
        propertyType: {
            1: 'Hiša',
            2: 'Stanovanje',
            3: 'Poslovni prostor',
            4: 'Posest',
            5: 'Garaža',
        },
    },
}
